module.exports = __webpack_public_path__ + "static/media/home-2.ada94cb5.jpg";